/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Start_AtInputs */

const vi_irrigation_run_start_at = /** @type {(inputs: Irrigation_Run_Start_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu lúc`)
};

/**

* @param {Irrigation_Run_Start_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_start_at = /** @type {((inputs?: Irrigation_Run_Start_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Start_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_start_at(inputs)
});